import { forwardRef, ReactNode } from "react";
import { RadioProps } from "../types";
import { STYLE_MAP } from "../styles";
import { FormFieldWrapper } from "../FormFieldWrapper";

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      label,
      errors,
      description,
      descriptionType,
      className = "",
      radioOptions,
      helperText,
      mode = "light",
      variant = "filled",
      horizontal = false,
      disabled = false,
      onChange,
      defaultCheckedValue,
      hideLabel,
      ...inputProps
    },
    ref
  ) => {
    const { name } = inputProps;

    return (
      <FormFieldWrapper
        {...{
          name,
          errors,
          label,
          description,
          descriptionType,
          helperText,
          mode,
          className,
          hideLabel
        }}
      >
        <div
          className={`flex  ${horizontal ? "flex-row gap-4" : "flex-col gap-"}`}
        >
          {radioOptions.map(({ value, label, description, Icon }) => (
            <div className={`${STYLE_MAP[mode][variant].primary}`} key={value}>
              <div className="flex gap-2  items-center ">
                <label
                  htmlFor={name + value}
                  className="flex items-center gap-3 w-full text-xs cursor-pointer py-1"
                >
                  <input
                    type="radio"
                    value={value}
                    id={name + value}
                    disabled={disabled}
                    ref={ref}
                    checked={defaultCheckedValue === value}
                    className=" border-gray-300 focus:ring-transparent checked:text-cyan-600 checked:ring-transparent h-3 w-3"
                    onChange={onChange}
                    {...inputProps}
                  />

                  <div className="flex items-center gap-1">
                    {Icon as ReactNode}
                    {label}
                  </div>
                </label>
              </div>
              {description && (
                <p
                  className={`${STYLE_MAP[mode]["text"].secondary} text-xs mt-1 `}
                >
                  {description}
                </p>
              )}
            </div>
          ))}
        </div>
      </FormFieldWrapper>
    );
  }
);
